import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import "react-datepicker/dist/react-datepicker.css";
import { getStorageData } from "../../utils/Validate";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import urls from "../../constants";
import { useScrollTrigger } from "@mui/material";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";

const NewEnquiryDetails = ({
  distributorData,
  customerInqName,
  setCustomerInqName,
  setValues,
  values,
  setErrors,
  errors,
  handleDocumentChange,
  setCountryInq,
  setAllocatedToInq,
  setCurrencyInq,
  setProjectInqName,
  setInquiryType,
  setAssignedInqEngineer,
  handleClick,
  setDistributorInq,
  distributorInq,
  filteredCustData,
  NoOptionsMessage,
  selectCustRef,
  handleFormChange,
  countryData,
  countryInq,
  assignedEngineerData,
  allocatedToInq,
  currencyData,
  currencyList,
  currencyInq,
  projectData,
  projectInqName,
  selectProjRef,
  inquiryTypes,
  inquiryType,
  handleDueDate,
  ExampleCustomInput,
  assignedInqEngineer,
  handleCheckChange,
  docError,
  removeAttachedFile,
  handleNotesChange,
  handleCancel,
  handleRedirect,
  loading,
  handleSubmit,
  filteredProjData
}) => {
  const [allocatedToData, setAllocatedToData] = useState([])
  const [engineerUnlocked, setEngineerUnlocked] = useState(false);
  const isAdminUser = getStorageData()?.roleId === urls?.ADMIN_ROLE_ID;

  const handleInqDropDownChange = (selectedOption, params) => {
    if (params === "customerInqName") {
      const custObj = filteredCustData?.find(el => el?.id === selectedOption?.value);
      setValues((prevValues) => ({
        ...prevValues,
        customerId: selectedOption?.value || "",
        customerAddress: custObj?.address || "",
        emailAddress: custObj?.email || "",
        mobileNo: custObj?.phone || "",
        salesEngineerId: custObj?.assignedEngineerId || ""
      }))
      setErrors({ ...errors, customerName: !selectedOption });
    }
    if (params === "countryInq") {
      setCountryInq(selectedOption);
      setValues({ ...values, countryId: selectedOption?.value, mobileNo: "" });
      setErrors({ ...errors, country: !selectedOption });
    }
    if (params === "allocatedToInq") {
      setAllocatedToInq(selectedOption);
      setValues({ ...values, allocatedTo: selectedOption?.value });
      setErrors({ ...errors, allocatedName: false });
    }
    if (params === "currencyInq") {
      setCurrencyInq(selectedOption);
      setValues({ ...values, currencyId: selectedOption?.value });
      setErrors({ ...errors, currency: !selectedOption });
    }
    if (params === "projectInqName") {
      setCustomerInqName(null);
      setAssignedInqEngineer(null);
      setAllocatedToInq(null);
      setValues((prevValues) => ({
        ...prevValues,
        projectId: selectedOption?.value || "",
        customerId: "",
        customerAddress: "",
        contactPerson: "",
        emailAddress: "",
        mobileNo: "",
        salesEngineerId: "",
        allocatedTo: "",
        customerRef: "",
        additionalInfo: "",
      }));
      setErrors({ ...errors, projectName: !selectedOption });
    }
    if (params === "inquiryType") {
      setInquiryType(selectedOption);
      setValues({ ...values, inquiryType: selectedOption?.value });
      setErrors({ ...errors, inquiryType: !selectedOption });
    }
    if (params === "assignedInqEngineer") {
      setAssignedInqEngineer(selectedOption);
      setValues((prevValues) => ({
        ...prevValues,
        salesEngineerId: selectedOption?.value,
      }));
    }
    if (params === "distributorInq") {
      setCustomerInqName(null);
      setProjectInqName(null);
      setAssignedInqEngineer(null);
      setValues((prevValues) => ({
        ...prevValues,
        distributorId: selectedOption?.value,
        customerId: "",
        projectId: "",
        customerAddress: "",
        customerRef: "",
        contactPerson: "",
        emailAddress: "",
        mobileNo: "",
        salesEngineerId: "",
        countryId: distributorData?.find(item => item.id === selectedOption?.value)?.countryId,
        currencyId: distributorData?.find(item => item.id === selectedOption?.value)?.currencyId,
        allocatedTo: "",
      }));
      setErrors({ ...errors, distributorName: !selectedOption });
    }
  };

  useEffect(() => {
    if (distributorInq?.defaultCompanyDistributor === true) {
      setAllocatedToData(assignedEngineerData?.filter(item =>
        urls?.BACK_OFFICE_ROLE_ID?.includes(item?.roleId) &&
        (item?.isActive === true || item?.identityId === values?.allocatedTo)))
    } else {
      setAllocatedToData(assignedEngineerData?.filter(item =>
        item?.userCompanyId === values?.distributorId &&
        (item?.isActive === true || item?.identityId === values?.allocatedTo)))
    }
  }, [distributorInq, assignedEngineerData, values?.distributorId])

  // Assigned Engineer options (distributor based)
  const assignedEngOption = useMemo(() => {
    if (!assignedEngineerData) return [];

    const isDefaultCompany = distributorInq?.defaultCompanyDistributor === true;

    return assignedEngineerData.filter(item =>
      (item?.isActive === true &&
        (isDefaultCompany || item?.userCompanyId === values?.distributorId)) ||
      item?.identityId === values?.salesEngineerId
    );
  }, [
    assignedEngineerData,
    distributorInq?.defaultCompanyDistributor,
    values?.distributorId,
    values?.salesEngineerId,
  ]);

  useEffect(() => {
    setEngineerUnlocked(false);
  }, [values?.customerId]);
  return (
    <div>
      <section className="new-enquiry-add-sec mt-2">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card new-enquiry-card">
              <div className="card-body px-2">
                <div className="card general-info-card">
                  <div className="card-header">
                    <h2>General Information</h2>
                  </div>
                  <div className="card-body">
                    <div className="row enquiry-row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 enquiry-column-left">
                        <div className="row">
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>Distributor</label>
                              <DropDownComponent
                                isDisabled={values?.id || getStorageData()?.userType == 2}
                                placeHolder={PlaceHolder?.SELECT_DISTRIBUTOR}
                                pageName="enquiry"
                                dpDownName="distributor"
                                stateData={distributorData}
                                controlName="distributorInq"
                                handleChange={(e) => handleInqDropDownChange(e, "distributorInq")}
                                value={distributorInq}
                                valueId={values?.distributorId}
                                setState={(value) => setDistributorInq(value)}
                                multiSelect={false}
                                checkLabel={false}
                              />
                              {errors.distributorName && (
                                <p className="form-error">
                                  {errors.distributorName}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>
                                Customer Name <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                isDisabled={
                                  !values?.id
                                    ? getStorageData().userType != 2 && distributorInq == undefined
                                      ? true
                                      : false
                                    : true
                                }
                                placeHolder={
                                  distributorInq == null || distributorInq == undefined
                                    ? `${PlaceHolder?.SELECT_DISTRIBUTOR_CUSTOMER}`
                                    : `${PlaceHolder?.SELECT_CUSTOMER}`
                                }
                                pageName="enquiry"
                                dpDownName="customer"
                                stateData={filteredCustData}
                                controlName="customerInqName"
                                handleChange={(e) => handleInqDropDownChange(e, "customerInqName")}
                                value={customerInqName}
                                valueId={values?.customerId}
                                setState={setCustomerInqName}
                                multiSelect={false}
                                checkLabel={false}
                                components={{ NoOptionsMessage }}
                                refComp={selectCustRef}
                              />
                              {errors.customerName && (
                                <p className="form-error">{errors.customerName}</p>
                              )}
                            </div>
                          </div>

                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>Customer Address </label>
                              <textarea
                                className="form-control customer-address-textarea"
                                placeholder={PlaceHolder?.ADDRESS}
                                rows="5"
                                name="customerAddress"
                                onChange={handleFormChange}
                                value={values?.customerAddress}
                              ></textarea>
                            </div>
                            {errors.customerAddress && (
                              <p className="form-error">{errors.customerAddress}</p>
                            )}
                          </div>
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>
                                Contact person <span className="mandatory">*</span>
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder={PlaceHolder?.CONTACT_NAME}
                                name="contactPerson"
                                onChange={handleFormChange}
                                value={values?.contactPerson}
                              ></input>
                              {errors.contactPerson && (
                                <p className="form-error">{errors.contactPerson}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>Email Address <span className="mandatory">*</span></label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder={PlaceHolder?.EMAIL_ADDRESS}
                                name="emailAddress"
                                onChange={handleFormChange}
                                value={values?.emailAddress}
                              ></input>
                              {errors.emailAddress && (
                                <p className="form-error">{errors.emailAddress}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 enquiry-column-right">
                        <div className="row">
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className="w-100 enquiry-label">
                                Project Name <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                isDisabled={
                                  getStorageData().userType != 2 && distributorInq == undefined
                                    ? true
                                    : false
                                }
                                placeHolder={
                                  distributorInq == null || distributorInq == undefined
                                    ? `${PlaceHolder?.SELECT_DISTRIBUTOR_PROJECT}`
                                    : `${PlaceHolder?.SELECT_PROJECT}`
                                }
                                pageName="enquiry"
                                dpDownName="project"
                                stateData={filteredProjData}
                                controlName="projectInqName"
                                handleChange={(e) => handleInqDropDownChange(e, "projectInqName")}
                                value={projectInqName}
                                valueId={values?.projectId}
                                setState={setProjectInqName}
                                multiSelect={false}
                                checkLabel={false}
                                components={{ NoOptionsMessage }}
                                refComp={selectProjRef}
                              />
                              {errors.projectName && (
                                <p className="form-error">{errors.projectName}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>Enquiry Reference</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder={PlaceHolder?.ENQUIRY_REFERENCE}
                                name="customerRef"
                                onChange={handleFormChange}
                                value={values?.customerRef}
                              ></input>
                              {errors.customerRef && (
                                <p className="form-error">{errors.customerRef}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>
                                Enquiry Type <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                pageName="Enquiry"
                                dpDownName="inquiryTypesdrp"
                                stateData={inquiryTypes}
                                controlName="inquiryType"
                                placeHolder={PlaceHolder?.ENQUIRY_TYPE}
                                handleChange={(e) =>
                                  handleInqDropDownChange(e, "inquiryType")
                                }
                                value={inquiryType}
                                valueId={values?.inquiryType}
                                setState={setInquiryType}
                              />

                              {errors.inquiryType && (
                                <p className="form-error">{errors.inquiryType}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>Enquiry Due Date <span className="mandatory">*</span></label>
                              <DatePicker
                                name="dueDate"
                                selected={values?.dueDate}
                                onChange={(date) => handleDueDate(date)}
                                customInput={<ExampleCustomInput />}
                                dayClassName={() => "example-datepicker-day-class"}
                                popperClassName="example-datepicker-class"
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                              />
                              {errors.dueDate && (
                                <p className="form-error">{errors.dueDate}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>
                                Currency <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                pageName="Enquiry"
                                placeHolder={PlaceHolder?.SELECT_CURRENCY}
                                dpDownName="currencyCode"
                                stateData={currencyList}
                                controlName="currencyInq"
                                handleChange={(e) =>
                                  handleInqDropDownChange(e, "currencyInq")
                                }
                                value={currencyInq}
                                valueId={values?.currencyId}
                                setState={setCurrencyInq}
                                isDisabled={distributorInq?.defaultCompanyDistributor === true ? false : true}
                              />
                              {errors.currency && (
                                <p className="form-error">{errors.currency}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <div className="d-flex align-items-center">
                                <label className='enquiry-label mb-0'>
                                  Assigned Engineer{" "}
                                  <span className="mandatory">*</span>
                                </label>
                                {values?.customerId && !engineerUnlocked && (
                                  <i
                                    className="far fa-edit"
                                    title="Edit assigned engineer"
                                    onClick={() => setEngineerUnlocked(true)}
                                    style={{ cursor: "pointer", fontSize: 14, marginLeft: 8, color: "#0b3c6f" }}
                                  ></i>
                                )}
                              </div>
                              <DropDownComponent
                                pageName="Enquiry"
                                placeHolder={values?.customerId ? PlaceHolder?.SELECT_ASSIGNED : PlaceHolder?.MUST_CHOOSE_FIELD("customer", "assigned engineer")}
                                dpDownName="assignedTo"
                                stateData={assignedEngOption}
                                controlName="assignedInqEngineer"
                                handleChange={(e) =>
                                  handleInqDropDownChange(e, "assignedInqEngineer")
                                }
                                value={assignedInqEngineer}
                                valueId={values?.salesEngineerId}
                                setState={setAssignedInqEngineer}
                                isDisabled={!(values?.customerId && engineerUnlocked)}
                              />
                              {errors.assignedEngineer && (
                                <p className="form-error">{errors.assignedEngineer}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>
                                Country <span className="mandatory">*</span>
                              </label>
                              <DropDownComponent
                                pageName="Enquiry"
                                placeHolder={PlaceHolder?.SELECT_COUNTRY}
                                dpDownName="country"
                                stateData={countryData}
                                controlName="countryInq"
                                handleChange={(e) =>
                                  handleInqDropDownChange(e, "countryInq")
                                }
                                value={countryInq}
                                valueId={values?.countryId}
                                setState={setCountryInq}
                                isDisabled={true}
                              />
                              {errors.country && (
                                <p className="form-error">{errors.country}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>
                                Phone Number <span className="mandatory">*</span>
                              </label>
                              <PhoneNumberComponent defaultCountry={countryInq?.code} errors={errors} setValues={setValues} setErrors={setErrors} filedName="mobileNo" values={values} />
                              {errors.mobileNo && (
                                <p className="form-error">{errors.mobileNo}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div>
                              <label className='enquiry-label'>
                                Allocated To
                              </label>
                              <DropDownComponent
                                placeHolder={getStorageData()?.userType === 2
                                  ? values?.distributorId
                                    ? PlaceHolder?.SELECT_ALLOCATED_TO
                                    : PlaceHolder?.MUST_CHOOSE_FIELD("distributor", "allocated to")
                                  : PlaceHolder?.SELECT_ALLOCATED_TO
                                }
                                pageName="Enquiry"
                                dpDownName="allocatedTo"
                                stateData={allocatedToData}
                                controlName="allocatedToInq"
                                handleChange={(e) =>
                                  handleInqDropDownChange(e, "allocatedToInq")
                                }
                                value={allocatedToInq}
                                valueId={values?.allocatedTo}
                                setState={setAllocatedToInq}
                                isDisabled={getStorageData()?.userType === 2
                                  ? values?.distributorId
                                    ? false
                                    : true
                                  : false
                                }
                              />
                              {errors.allocatedName && (
                                <p className="form-error">{errors.allocatedName}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-3 mb-2">
                        <div>
                          <label className='enquiry-label'>Additional info </label>
                          <textarea
                            className="form-control"
                            placeholder={PlaceHolder?.ADDITIONAL_NOTES}
                            rows="5"
                            name="additionalInfo"
                            onChange={handleFormChange}
                            value={values?.additionalInfo}
                          ></textarea>
                          {errors.additionalInfo && (
                            <p className="form-error">{errors.additionalInfo}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mt-1 mb-2 upload-specification-card">
                  <div class="card-header">
                    <h2>Upload specification and schedule</h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                        <div className="table-responsive customer-documents-table-sec">
                          <table className="table table-striped table-borderless">
                            <tbody>
                              {values?.inquiryProducts?.length != 0 &&
                                values?.inquiryProducts?.map((pdt, index) => {
                                  return (
                                    <><tr key={pdt?.id}>
                                      <td>
                                        <div className="d-flex">
                                          <div class="form-group">
                                            <input
                                              type="checkbox"
                                              id={`isActiveProduct-${pdt?.id}`}
                                              name={`isActiveProduct-${pdt?.id}`}
                                              value={pdt?.checked}
                                              checked={pdt?.checked}
                                              onChange={(e) => handleCheckChange(e, index)} />
                                            <label
                                              className="mb-0"
                                              for={`isActiveProduct-${pdt?.id}`}>{pdt?.shortDesc}</label>
                                          </div>
                                        </div>
                                        <div>
                                          {docError[index] && (
                                            <p className="form-error">
                                              {" "}
                                              {docError[index]}{" "}
                                            </p>
                                          )}
                                        </div>
                                      </td>
                                      <td style={{ width: "35%" }}>
                                        <div
                                          id="file-upload-form"
                                          className="upload-btn"
                                        >
                                          {pdt?.fileName == "" ? (<><input
                                            id={`file-upload-attachment-${pdt?.id}`}
                                            type="file"
                                            name="fileUpload"
                                            accept=".pdf"
                                            onChange={(e) => handleDocumentChange(e, pdt?.id)}
                                            onClick={(e) => {
                                              e.target.value = null;
                                            }}
                                            disabled={!pdt?.checked} />
                                            <label
                                              for={`file-upload-attachment-${pdt?.id}`}
                                              id="file-drag"
                                            >
                                              <p>Attach File</p>
                                              <span class="material-icons-outlined">
                                                file_upload
                                              </span>
                                            </label></>
                                          ) : (
                                            <label>
                                              <p>{pdt?.fileName}</p>
                                              <i
                                                className="fas fa-times"
                                                onClick={(e) => removeAttachedFile(pdt?.id, index)}
                                              ></i>
                                            </label>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                      <tr style={{ display: pdt?.checked ? "table-row" : "none" }}>
                                        <td colSpan="2">
                                          <div>
                                            <label className='enquiry-label'>Add Notes</label>
                                            <textarea
                                              className="form-control"
                                              placeholder={PlaceHolder?.ADDITIONAL_NOTES}
                                              rows="5"
                                              name="productNotes"
                                              onChange={(e) => handleNotesChange(e, pdt?.id, index)}
                                              value={pdt?.file?.productNotes}
                                            ></textarea>
                                          </div>
                                        </td>
                                      </tr></>
                                  )
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-2 px-3">
                    <div className="save-btns d-flex justify-content-end">
                      <button
                        className="btn cancel-btn"
                        onClick={handleRedirect}
                      >
                        Cancel{" "}
                      </button>
                      <button
                        className={`btn save-btn ${loading ? "disable-savebtn" : ""
                          }`}
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {values?.id ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewEnquiryDetails;
